import OBase from './OBase';

import * as Geometry from '../geometry';

export default class ValueList extends OBase {
  update () {
    let pOutput = this.getGenericObjectOutput('Value List');

    let selected = Number(this.ghGeometryObject.selected);
    let value = this.ghGeometryObject.values[selected];

    let outTree = new Geometry.DataTree();
    outTree.add(value, new Geometry.GHPath(0));
    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ValueList.js